import gql from 'graphql-tag';

const GET_NETWORK_CREDENTIAL_LIST = gql`
  query($listInfo: ListInfoInput!) {
    getNetworkCredentialList(listInfo: $listInfo) {
      credentials {
        credentialId
        name
        description
        protocol
        type
        createdBy {
          name
        }
        client {
          accountId
          name
        }
        sites {
          id
          name
        }
        createdTime
        updatedTime
      }
      listInfo {
        page
        pageSize
        totalCount
        sort {
          attribute
          order
        }
      }
    }
  }
`;

const GET_NETWORK_CREDENTIAL = gql`
  query($credentialId: ID!) {
    getNetworkCredential(credentialId: $credentialId) {
      credentialId
      name
      description
      protocol
      data
      type
      createdBy {
        name
      }
      client {
        accountId
        name
      }
      sites {
        id
        name
      }
      createdTime
      updatedTime
    }
  }
`;
const GET_NETWORK_CREDENTIAL_PROTOCOL_LIST = gql`
  query getNetworkCredentialProtocolList {
    getNetworkCredentialProtocolList
  }
`;

const GET_NETWORK_CREDENTIAL_META = gql`
  query getNetworkCredentialMeta($protocol: String!) {
    getNetworkCredentialMeta(protocol: $protocol)
  }
`;

const CREATE_NETWORK_CREDENTIAL = gql`
  mutation($credentialInput: CredentialInput!) {
    createNetworkCredential(input: $credentialInput) {
      name
      description
      protocol
      type
      data
      createdTime
      updatedTime
    }
  }
`;

const UPDATE_NETWORK_CREDENTIAL = gql`
  mutation($credentialId: ID, $credentialInput: CredentialInput!) {
    updateNetworkCredential(
      credentialId: $credentialId
      input: $credentialInput
    ) {
      credentialId
      name
      description
      protocol
      type
      data
      createdTime
      updatedTime
      createdBy {
        name
      }
    }
  }
`;

const DELETE_CREDENTIALS = gql`
  mutation($credentialIds: [ID!]) {
    deleteCredentials(credentialIds: $credentialIds)
  }
`;

const GET_VIEWS = gql`
  query getViews($modules: [ID!]) {
    getViews(modules: $modules) {
      module
      views {
        id
        name
        customView
        shared
        systemViewProperty
        viewSubType
      }
    }
  }
`;

const GET_NETWORK_SCAN_META_INFO = gql`
  query {
    getNetworkScanMetaInfo
  }
`;

const GET_NETWORK_SCANS = gql`
  query($listInfo: ListInfoInput) {
    getNetworkScans(listInfoInput: $listInfo) {
      listInfo {
        page
        pageSize
        totalCount
        sort {
          attribute
          order
        }
      }
      networkScans {
        networkId
        networkMask
        client {
          accountId
          name
        }
        site {
          id
          name
        }
        lastScanCompletedTime
        addedToMonitoring
        ignored
        scanInProgress
        userAdded
        supportedProtocols
        totalAssetCount
        associatedProbes
      }
    }
  }
`;

const GET_NETWORKS = gql`
  query($listInfo: ListInfoInput) {
    getNetworks(listInfoInput: $listInfo) {
      listInfo {
        page
        pageSize
        totalCount
        sort {
          attribute
          order
        }
      }
      networks {
        networkId
        networkMask
        client {
          accountId
          name
        }
        site {
          id
          name
        }
        lastScanCompletedTime
        addedToMonitoring
        ignored
        scanInProgress
        userAdded
        supportedProtocols
        # totalAssetCount
        associatedProbes
        unManagedAssetCount
      }
    }
  }
`;

const GET_NETWORK_ENTITY_PROPERTIES = gql`
  query {
    getEntitiesMeta(
      entityNames: [
        "Network"
        "Client"
        "Site"
        "ScannedAsset"
        "NetworkCredential"
        "AssetModel"
        "AssetMake"
        "scannedAssetNetworkInfo"
      ]
    ) {
      label
      name
      # reportEnabled
      attributes {
        name
        label
        attributePlaceHolder {
          key
          label
        }
        filterType
        isIdentifier
        isKeyAttribute
        dataType
        entity
        uiDataType
        conditionPlaceHolders {
          key
          label
        }
        isCustom
        isDependent
        nestedAttributes
        nestedTo
        showToClient
        autoComplete
        useInMetric
        metricFunctions
        labelInMetric
        useInGroupBy
        useInCondition
        conditionPlaceHoldersMeta
      }
    }
  }
`;

const GET_SCANNED_ASSET_META_INFO = gql`
  query getScannedAssetMetaInfoV2($category: String) {
    getScannedAssetMetaInfoV2(category: $category)
  }
`;

const GET_DISCOVERED_ASSET_META = gql`
  query getDiscoveredAssetMeta($isEndpoint: Boolean!) {
    getDiscoveredAssetMeta(isEndpoint: $isEndpoint)
  }
`;

const GET_SCANNED_ASSETS = gql`
  query(
    $scanStatus: [String]
    $categories: [String]
    $listInfo: ListInfoInput!
    $networkId: ID
    $ignoredAssets: Boolean
  ) {
    getScannedAssetsV2(
      scanStatus: $scanStatus
      listInfoInput: $listInfo
      networkId: $networkId
      ignoredAssets: $ignoredAssets
      categories: $categories
    ) {
      scannedAssets {
        assetId
        ipAddress
        client {
          accountId
          name
        }
        site {
          id
          name
        }
        name
        monitoredAssetId
        assetMake {
          makeId
          name
        }
        assetModel {
          modelId
          name
        }
        deviceType
        credential {
          credentialId
          name
        }
        failedReason
        scanInProgress
        isGenericSysObjectAsset
        monitoringOptions
        monitoredAssetId
        agentInstallStatus
        installerErrorMsg
        assetClass {
          classId
          iconClass
        }
        architecture
      }
      listInfo {
        page
        pageSize
        totalCount
        sort {
          attribute
          order
        }
      }
    }
  }
`;

const GET_NETWORK_DISCOVERED_ASSETS = gql`
  query getNetworkDiscoveredAssets(
    $listInfo: ListInfoInput
    $input: DiscoveredAssetsInput
  ) {
    getNetworkDiscoveredAssets(input: $input, listInfo: $listInfo) {
      assets {
        assetId
        ipAddress
        client {
          accountId
          name
        }
        site {
          id
          name
        }
        name
        # monitoredAssetId
        assetMake {
          makeId
          name
        }
        assetModel {
          modelId
          name
        }
        deviceType
        # credential {
        #   credentialId
        #   name
        # }
        # failedReason
        # scanInProgress
        # isGenericSysObjectAsset
        monitoringOptions
        # monitoredAssetId
        # agentInstallStatus
        # installerErrorMsg
        assetClass {
          classId
          iconClass
        }
        architecture
        installerMessage
        installerStatus
      }
      listInfo {
        page
        pageSize
        totalCount
        sort {
          attribute
          order
        }
      }
    }
  }
`;

const GET_NETWORK_SCAN_DEVICES_COUNT = gql`
  query getNetworkScanDevicesCount(
    $networkId: ID
    $condition: RuleConditionInput
    $category: String
  ) {
    getNetworkScanDevicesCount(
      networkId: $networkId
      condition: $condition
      category: $category
    )
  }
`;

const GET_DISCOVERED_ASSETS_COUNT = gql`
  query getDiscoveredAssetsCount(
    $isEndpoint: Boolean!
    $isSNMPSuccess: Boolean
    $networkIds: [ID!]
    $condition: RuleConditionInput
  ) {
    getDiscoveredAssetsCount(
      isEndpoint: $isEndpoint
      isSNMPSuccess: $isSNMPSuccess
      networkIds: $networkIds
      condition: $condition
    )
  }
`;

const ADD_SCANNED_ASSET_FOR_MONITORING = gql`
  mutation($assetIds: [ID!]) {
    addScannedAssetForMonitoring(assetIds: $assetIds) {
      status
      successCount
      failureCount
      failedAsset {
        assetId
        name
      }
    }
  }
`;

const MONITOR_ASSETS = gql`
  mutation($assetIds: [ID!]) {
    monitorAssets(assetIds: $assetIds) {
      status
      successCount
      failureCount
    }
  }
`;

const TRIGGER_AGENT_INSTALL = gql`
  mutation triggerAgentInstall($assetIds: [ID!]!) {
    triggerAgentInstall(assetIds: $assetIds)
  }
`;

const TRIGGER_AGENT_INSTALL_V2 = gql`
  mutation triggerAgentInstallV2($assetIds: [ID!]!) {
    triggerAgentInstallV2(assetIds: $assetIds)
  }
`;

const IGNORE_SCANNED_ASSET = gql`
  mutation($assetIds: [ID!]) {
    ignoreScannedAsset(assetIds: $assetIds)
  }
`;

const IGNORE_UNMANAGED_ASSET = gql`
  mutation($assetIds: [ID!]) {
    ignoreUnManagedAsset(assetIds: $assetIds)
  }
`;

const RESTORE_IGNORED_ASSET_FOR_SCAN = gql`
  mutation($assetIds: [ID!]) {
    restoreIgnoredAssetForScan(assetIds: $assetIds)
  }
`;

const RESTORE_UNMANAGED_ASSET = gql`
  mutation($assetIds: [ID!]) {
    restoreUnManagedAsset(assetIds: $assetIds)
  }
`;

const RETRY_NETWORK_SCAN = gql`
  mutation($assetIds: [ID!]) {
    retryNetworkScan(assetIds: $assetIds)
  }
`;

const INITIATE_NETWORK_SCAN = gql`
  mutation($networkIds: [ID!]) {
    initiateNetworkScan(networkIds: $networkIds)
  }
`;

const INITIATE_NETWORK_SCAN_V2 = gql`
  mutation($input: SelectionInput!) {
    initiateNetworkScanV2(input: $input)
  }
`;

const GET_ACTIVE_ASSET_INTERFACES = gql`
  query($assetId: ID!) {
    getActiveAssetInterfaces(assetId: $assetId) {
      subNetMask
    }
  }
`;

const CONVERT_ASSET_TO_PROBE = gql`
  mutation($assetId: ID!, $scanNow: Boolean, $supportedProtocols: [String]) {
    convertAssetToProbe(
      assetId: $assetId
      scanNow: $scanNow
      supportedProtocols: $supportedProtocols
    )
  }
`;

const GET_CREDENTIAL_COUNT = gql`
  query($clientId: ID, $siteId: ID) {
    getCredentialsCount(clientId: $clientId, siteId: $siteId)
  }
`;

const ADD_NETWORK = gql`
  mutation($input: NetworkInput!) {
    addNetwork(input: $input)
  }
`;

const DELETE_NETWORK = gql`
  mutation($networkId: ID!) {
    deleteNetwork(networkId: $networkId)
  }
`;

const GET_NETWORK_SCAN_CREDENTIAL_DATA = gql`
  query getNetworkScanCredentialData($networkId: ID!) {
    getNetworkScanCredentialData(networkId: $networkId)
  }
`;

const GET_NETWORK_SCHEDULE_CONFIG = gql`
  query getNetworkScanScheduleConfig {
    getNetworkScanScheduleConfig
  }
`;

const UPDATE_NETWORK_SCHEDULE_CONFIG = gql`
  mutation($scheduleDetails: JSON!) {
    updateNetworkScanSchedule(scheduleDetails: $scheduleDetails)
  }
`;

const UPDATE_MAKE_MODEL = gql`
  mutation($assetId: ID, $deviceType: String, $model: String) {
    updateScannedAssetDeviceTypeAndModel(
      assetId: $assetId
      deviceType: $deviceType
      model: $model
    )
  }
`;

const UPDATE_NETWORK = gql`
  mutation($networkId: ID!, $input: NetworkInput!) {
    updateNetwork(networkId: $networkId, input: $input)
  }
`;

const GET_ASSET_CLASS_LAYOUT = gql`
  query getAssetClassLayout(
    $classId: ID!
    $layoutId: ID
    $assetId: ID
    $fetchRoot: Boolean
  ) {
    getAssetClassLayout(
      classId: $classId
      layoutId: $layoutId
      assetId: $assetId
      fetchRoot: $fetchRoot
    )
  }
`;

const GET_TABLE_DATA = gql`
  query getTableData($assetId: ID!, $tableIds: [ID!]) {
    getTableData(assetId: $assetId, tableIds: $tableIds)
  }
`;

const GET_ASSET_GRID_DATA = gql`
  query getAssetGridData($assetId: ID!, $gridIds: [ID!]) {
    getAssetGridData(assetId: $assetId, gridIds: $gridIds)
  }
`;

const GET_AVAILABILITY_MONITOR_DETAILS = gql`
  query getAvailabilityMonitorDetails($assetId: ID!) {
    getAvailabilityMonitorDetails(assetId: $assetId)
  }
`;

const GET_ASSET_WIDGET_DATA = gql`
  query getAssetWidgetData($assetId: ID!, $widgetIds: [ID!]) {
    getAssetWidgetData(assetId: $assetId, widgetIds: $widgetIds)
  }
`;

const GET_NETWORK_MONITORING_ASSET_CLASSES = gql`
  query getNetworkMonitoringAssetClasses {
    getNetworkMonitoringAssetClasses
  }
`;

const CREATE_ASSET_MODEL = gql`
  mutation($makeId: ID!, $modelName: String!, $classId: ID!) {
    createAssetModel(
      makeId: $makeId
      modelName: $modelName
      classId: $classId
    ) {
      modelId
      name
    }
  }
`;
const UPDATE_SCANNED_ASSETS = gql`
  mutation($assetIds: [ID!], $classId: ID!, $makeId: ID!, $modelId: ID!) {
    updateScannedAssets(
      assetIds: $assetIds
      classId: $classId
      makeId: $makeId
      modelId: $modelId
    )
  }
`;

const UPDATE_UNMANAGED_ASSETS = gql`
  mutation($assetIds: [ID!], $classId: ID!, $makeId: ID!, $modelId: ID!) {
    updateUnManagedAssets(
      assetIds: $assetIds
      classId: $classId
      makeId: $makeId
      modelId: $modelId
    )
  }
`;

const UPDATE_MONITORED_ASSET_MODEL = gql`
  mutation updateMonitoredAssetsModel($assetIds: [ID!], $modelId: ID!) {
    updateMonitoredAssetsModel(assetIds: $assetIds, modelId: $modelId)
  }
`;

const GET_NETWORK_PROTOCOL_LIST = gql`
  query getNetworkProtocolList($credentialSupported: Boolean) {
    getNetworkProtocolList(credentialSupported: $credentialSupported)
  }
`;

const GET_ASSET_MONITORING_OPTIONS = gql`
  query getAssetMonitoringOptions($monitoredAssetId: ID!) {
    getAssetMonitoringOptions(monitoredAssetId: $monitoredAssetId)
  }
`;

const UPDATE_ASSET_MONITORING_OPTIONS = gql`
  mutation updateAssetMonitoringOptions(
    $monitoredAssetId: ID!
    $monitoringOptionsInput: JSON!
  ) {
    updateAssetMonitoringOptions(
      monitoredAssetId: $monitoredAssetId
      monitoringOptionsInput: $monitoringOptionsInput
    )
  }
`;

const GET_ENDPOINT_CREDENTIAL_META = gql`
  query($version: ID) {
    getAssetCredentialMeta(version: $version)
  }
`;
const GET_ENDPOINT_CREDENTIALS = gql`
  query($credentialId: ID!) {
    getManagedUserCredential(credentialId: $credentialId) {
      credentialId
      name
      assetClass {
        classId
        name
        iconClass
      }
      data
      createdBy {
        name
      }
      client {
        accountId
        name
      }
      site {
        id
        name
      }
      asset {
        assetId
        name
      }
      createdTime
      updatedTime
    }
  }
`;
const GET_EDNPOINT_CREDENTIALS_LIST = gql`
  query($listInfo: ListInfoInput!) {
    getManagedUserCredentialList(listInfo: $listInfo) {
      credentials {
        credentialId
        name
        assetClass {
          classId
          name
          iconClass
        }
        createdBy {
          name
        }
        client {
          accountId
          name
        }
        site {
          id
          name
        }
        asset {
          assetId
          name
        }
        createdTime
        updatedTime
      }
      listInfo {
        page
        pageSize
        totalCount
        sort {
          attribute
          order
        }
      }
    }
  }
`;
const CREATE_ENDPOINT_CREDENTIAL = gql`
  mutation($credentialInput: ManagedUserCredentialInput!) {
    createManagedUserCredential(input: $credentialInput) {
      credentialId
      name
      assetClass {
        classId
        name
        iconClass
      }
      data
      createdBy {
        name
      }
      client {
        accountId
        name
      }
      site {
        id
        name
      }
      asset {
        assetId
        name
      }
      createdTime
      updatedTime
    }
  }
`;
const UPDATE_ENPOINT_CREDENTIAL = gql`
  mutation($credentialId: ID, $credentialInput: ManagedUserCredentialInput!) {
    updateManagedUserCredential(
      credentialId: $credentialId
      input: $credentialInput
    ) {
      credentialId
      name
      assetClass {
        classId
        name
        iconClass
      }
      data
      createdBy {
        name
      }
      client {
        accountId
        name
      }
      site {
        id
        name
      }
      asset {
        assetId
        name
      }
      createdTime
      updatedTime
    }
  }
`;
const DELETE_ENDPOINT_CREDENTIAL = gql`
  mutation deleteManagedUserCredentials($credentialIds: [ID!]) {
    deleteManagedUserCredentials(credentialIds: $credentialIds)
  }
`;
const CREDENTIALS_LIST_META = gql`
  query($version: ID!, $entity: String!) {
    getCredentialMeta(version: $version, entity: $entity)
  }
`;
const GET_CREDENTIAL_SUPPORTED_ASSET_CLASS_LIST = gql`
  query {
    getCredentialSupportedAssetClassList {
      classId
      name
      iconClass
    }
  }
`;

export {
  GET_NETWORK_CREDENTIAL_LIST,
  GET_NETWORK_CREDENTIAL_META,
  CREATE_NETWORK_CREDENTIAL,
  DELETE_CREDENTIALS,
  GET_NETWORK_CREDENTIAL,
  UPDATE_NETWORK_CREDENTIAL,
  GET_VIEWS,
  GET_NETWORK_SCAN_META_INFO,
  GET_NETWORK_SCANS,
  GET_NETWORK_ENTITY_PROPERTIES,
  GET_SCANNED_ASSET_META_INFO,
  GET_SCANNED_ASSETS,
  GET_NETWORK_SCAN_DEVICES_COUNT,
  ADD_SCANNED_ASSET_FOR_MONITORING,
  IGNORE_SCANNED_ASSET,
  INITIATE_NETWORK_SCAN,
  INITIATE_NETWORK_SCAN_V2,
  RETRY_NETWORK_SCAN,
  GET_ACTIVE_ASSET_INTERFACES,
  CONVERT_ASSET_TO_PROBE,
  GET_CREDENTIAL_COUNT,
  ADD_NETWORK,
  DELETE_NETWORK,
  GET_NETWORK_SCAN_CREDENTIAL_DATA,
  RESTORE_IGNORED_ASSET_FOR_SCAN,
  GET_NETWORK_SCHEDULE_CONFIG,
  UPDATE_NETWORK_SCHEDULE_CONFIG,
  UPDATE_MAKE_MODEL,
  UPDATE_NETWORK,
  GET_ASSET_CLASS_LAYOUT,
  GET_TABLE_DATA,
  GET_ASSET_GRID_DATA,
  GET_ASSET_WIDGET_DATA,
  GET_AVAILABILITY_MONITOR_DETAILS,
  GET_NETWORK_MONITORING_ASSET_CLASSES,
  CREATE_ASSET_MODEL,
  UPDATE_SCANNED_ASSETS,
  UPDATE_MONITORED_ASSET_MODEL,
  GET_NETWORK_PROTOCOL_LIST,
  GET_ASSET_MONITORING_OPTIONS,
  UPDATE_ASSET_MONITORING_OPTIONS,
  GET_NETWORK_CREDENTIAL_PROTOCOL_LIST,
  TRIGGER_AGENT_INSTALL,
  GET_DISCOVERED_ASSETS_COUNT,
  GET_NETWORK_DISCOVERED_ASSETS,
  GET_DISCOVERED_ASSET_META,
  GET_NETWORKS,
  UPDATE_UNMANAGED_ASSETS,
  RESTORE_UNMANAGED_ASSET,
  IGNORE_UNMANAGED_ASSET,
  TRIGGER_AGENT_INSTALL_V2,
  MONITOR_ASSETS,
  GET_ENDPOINT_CREDENTIAL_META,
  GET_ENDPOINT_CREDENTIALS,
  CREATE_ENDPOINT_CREDENTIAL,
  GET_EDNPOINT_CREDENTIALS_LIST,
  UPDATE_ENPOINT_CREDENTIAL,
  DELETE_ENDPOINT_CREDENTIAL,
  CREDENTIALS_LIST_META,
  GET_CREDENTIAL_SUPPORTED_ASSET_CLASS_LIST
};
